module.exports = __webpack_public_path__ + "static/media/hilabs_gold_star.2867882c.png";